import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Column, DataTable, DataTableContainer, TableActionButton } from 'components/DataTable';
import { timeDivisions } from 'components/TrainingPlan/TrainingPlanHelpers';
import { useApi } from '../../../hooks/useApi';
import { useConfirmedAction } from 'hooks/useConfirmedAction';
import { useModal } from 'hooks/useModal';
import moment from 'moment';
import { useRef } from 'react';
import { SpaceSubscription } from '../types';
import { SpaceSubscriptionForm } from './SpaceSubscriptionForm';
import { Button } from '@ui';

interface Props {
    clubSlug: string;
}

export const SpaceSubscriptionList = ({ clubSlug }: Props) => {
    const api = useApi();
    const [setModal, resetModal] = useModal();
    const confirmedAction = useConfirmedAction();
    const asyncList = useRef<any>(undefined);

    const handleShowSpaceSubscriptionForm = (spaceSubscription?: SpaceSubscription) =>
        setModal({
            title: spaceSubscription ? `"${spaceSubscription.title}" bearbeiten` : 'Neues Abo erstellen',
            content: (
                <SpaceSubscriptionForm
                    clubSlug={clubSlug}
                    subscription={spaceSubscription}
                    callback={() => {
                        asyncList.current?.reload();
                        resetModal();
                    }}
                />
            ),
            show: true,
            size: 60
        });

    const handleDeleteSubscription = (spaceSubscription: SpaceSubscription) => {
        api({
            url: `space/subscription/${spaceSubscription.id}`,
            method: 'DELETE',
            onSuccess: () => {
                asyncList.current?.reload();
                resetModal();
            }
        });
    };

    const columns: Column<SpaceSubscription>[] = [
        {
            uid: 'title',
            name: 'Titel'
        },
        {
            uid: 'spaces',
            name: '# Plätze',
            renderer(_, item?) {
                return item.spaces?.length;
            }
        },
        {
            uid: 'dates',
            name: 'Start- und Enddatum',
            renderer(_, item?) {
                return `${moment(item.start).format('l')} - ${moment(item.end).format('l')}`;
            }
        },
        {
            uid: 'times',
            name: 'Start- und Endzeit',
            renderer(_, item?) {
                return `${timeDivisions.times[item.start_time]} - ${timeDivisions.times[item.end_time]}`;
            }
        },
        {
            uid: 'repeat_period',
            name: 'Wiederholen'
        },
        {
            uid: 'actions',
            name: 'Optionen',
            align: 'end'
        }
    ];

    return (
        <DataTableContainer>
            <Button className="tw-p-y-5" onPress={() => handleShowSpaceSubscriptionForm()}>
                Abo erstellen
            </Button>
            <DataTable
                tableProps={{
                    sticked: true,
                    bordered: true,
                    borderWeight: 'light',
                    compact: false
                }}
                hideSearchBar
                asyncListRef={asyncList}
                columns={columns}
                fetchUrl={`space/subscription/${clubSlug}`}
                rowActions={(item) => (
                    <TableActionButton.Container justify="end">
                        <TableActionButton icon={faEdit} onClick={() => handleShowSpaceSubscriptionForm(item)} />
                        <TableActionButton
                            icon={faTrash}
                            onClick={() => confirmedAction(() => handleDeleteSubscription(item))}
                        />
                    </TableActionButton.Container>
                )}
            />
        </DataTableContainer>
    );
};

export default SpaceSubscriptionList;
